import * as yup from "yup";
import { requiredMsg, emailMsg } from './../../resources/lang/en/form_validation';

export const schema = yup.object().shape({
    email: yup.string().email(emailMsg('Email')).required(requiredMsg('Email')),
    password: yup.string().required(requiredMsg('Password')),
  });

 export const forgotPasswordSchema =  yup.object().shape({
  femail: yup.string().email(emailMsg('Email')).required(requiredMsg('Email')),
});

export const updatePasswordSchema =  yup.object().shape({
  fotp: yup.string().required(requiredMsg('OTP')),
  femail: yup.string().email(emailMsg('Email')).required(requiredMsg('Email')),
  fpassword: yup.string().required(requiredMsg('New Password')),
  fcpassword: yup.string()
       .oneOf([yup.ref('fpassword'), null], 'New Password and Confirm New Password didn\'t match')
       .required(requiredMsg('New Confirm Password')),
       

});
